var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Footer/LanguageMenu/LanguageListLO.tsx",
  _this = this;
import React, { useContext } from 'react';
import { defineMessages, T } from '@sm/intl';
import { getClientEnvironmentDetails } from '@sm/utils';
import getFooterLanguageList from './helpers/getFooterLanguageList';
import { InlineList, InlineListItem } from '../InlineList';
import { SMFooterContext } from '../SMFooterContext';
var COPY = defineMessages({
  LANGUAGES: {
    id: 'LanguageListLO.languageMenu',
    defaultMessage: 'Language:',
    description: '[Type: Label][Vis.: med] - A label for logged out footer language list'
  }
});
var LanguageListLO = function LanguageListLO() {
  var _useContext = useContext(SMFooterContext),
    subdomain = _useContext.subdomain,
    domain = _useContext.domain,
    _useContext$tld = _useContext.tld,
    tld = _useContext$tld === void 0 ? 'com' : _useContext$tld,
    url = _useContext.url;

  // if SSR, build the url from the request
  var SSRUrl = "https://".concat(subdomain, ".").concat(domain, ".").concat(tld).concat(url);
  var envDetails = getClientEnvironmentDetails();
  var location = new URL(envDetails.isBrowser ? window.location.href : SSRUrl);
  var languages = getFooterLanguageList(location.href, tld);
  var orderedLanguages = languages.sort(function (a, b) {
    return (!a.sortOrder ? 0 : a.sortOrder) > (!b.sortOrder ? 0 : b.sortOrder) ? -1 : 1;
  });
  var languageItems = orderedLanguages.map(function (lang) {
    return /*#__PURE__*/React.createElement(InlineListItem, {
      key: "".concat(lang.name, "-").concat(lang.sortOrder),
      href: "https://".concat(lang.subdomain, ".").concat(domain, ".").concat(lang.tld).concat(location.pathname, "?ut_source=footer"),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 34,
        columnNumber: 7
      }
    }, lang.displayName);
  });
  return /*#__PURE__*/React.createElement(InlineList, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(InlineListItem, {
    isTitle: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.LANGUAGES,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 9
    }
  })), languageItems);
};
export default LanguageListLO;
//# sourceMappingURL=LanguageListLO.js.map